import styled from 'styled-components'

export const Container = styled.div`
  background-color: #36393f;
  width: 100%;
  min-height: 100vh;
`
